const { getOffsetTop } = window.BAO.Utils

class FixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)
    this.onTrigger = this.onTrigger.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll)
    this.els.trigger.element.addEventListener('click', this.onTrigger)
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  onTrigger () {
    this.externalEls.details.element.scrollIntoView()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setVisibility()
  }

  setVisibility () {
    this.setAttribute('aria-hidden', !this.shouldBeVisible)
  }

  get shouldBeVisible () {
    if (!this.externalEls?.form?.exists) return

    const formFooter = this.externalEls.form.element
    const pageFooter = this.externalEls.footer.element

    if (
      this.lastKnownY > getOffsetTop(formFooter) + formFooter.offsetHeight &&
      this.lastKnownY < getOffsetTop(pageFooter) - window.innerHeight
    ) {
      return true
    } else {
      return false
    }
  }
}

if (!customElements.get('fixed-bar')) {
  customElements.define('fixed-bar', FixedBar)
}
